// extracted by mini-css-extract-plugin
export default {"searcherEmptyComponent":"searcher-module__searcherEmptyComponent__N2zOn","searcherStatusContainer":"searcher-module__searcherStatusContainer__Od4US"};